import * as api from '../api';
import { Model } from '../common';

@Model('GatewayMembershipStatus')
export class GatewayMembershipStatus extends api.ApiGatewayMembershipStatus {

}